<template>
  <div class="funnel-content p-3 pt-2">
    <b-tabs :class="{ editing }" v-model="tabIndex" fill>
      <b-tab title="Nova etapa">
        <snow-input
          v-model="form.name"
          required
          class="mt-4"
          label="Nome da etapa"
          :errors="errors.name"
        />

        <snow-select
          v-model="form.product_id"
          :loading="loadingProducts"
          required
          label="Produto"
          class="mt-4"
          :options="productList"
          :errors="errors.product_id"
        />
        <template v-if="selectedProduct">
          <snow-select
            v-if="isSignature"
            v-model="form.plan_id"
            :loading="loadingOffersPlans"
            required
            class="mt-4"
            label="Plano"
            :options="productPlans"
            :errors="errors.plan_id"
          />
          <snow-select
            v-else
            v-model="form.offer_id"
            :loading="loadingOffersPlans"
            required
            class="mt-4"
            label="Oferta"
            :options="productOffers"
            :errors="errors.offer_id"
          />
        </template>
        <snow-input
          v-model="form.cta_text"
          required
          class="mt-4"
          type="textarea"
          label="Texto para ação de efetuar a compra"
        />
        <snow-input
          v-model="form.ctb_text"
          required
          class="mt-4"
          type="textarea"
          label='Texto para opção "não"'
        />

        <snow-input
          v-model="form.url_cta"
          class="mt-4"
          label="URL da página da oferta"
          :errors="errors.url_cta"
        />
      </b-tab>

      <b-tab title="Página de obrigado" class="mt-4">
        <snow-input
          v-model="form.name"
          required
          class="mt-3"
          label="Nome da etapa"
          :errors="errors.name"
        />
        <snow-input
          v-model="form.url_cta"
          required
          class="mt-5 mb-6"
          label="URL da página de obrigado"
          :errors="errors.url_cta"
        />
      </b-tab>
    </b-tabs>

    <div class="snow-submit-buttons mt-7">
      <snow-button
        size="lg"
        text="Cancelar"
        variant="gray"
        @click="() => $emit('close')"
      />
      <snow-button
        size="lg"
        text="Salvar"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { clearObject, formFields } from "@/functions/helpers";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    stepToEdit: {
      type: Object,
      default: () => {}
    },
    action: String
  },
  data() {
    return {
      loadingProducts: false,
      loadingOffersPlans: false,
      tabIndex: this.stepToEdit?.is_end ? 1 : 0,
      ...formFields(
        [
          "id",
          "name",
          "parent",
          "is_active",
          "product_id",
          "offer_id",
          "plan_id",
          "cta_text",
          "ctb_text",
          "url_cta",
          "is_end",
          "method_payment"
        ],
        {
          is_end: false,
          is_active: true,
          method_payment: "card",
          ...(this.stepToEdit || {}),
          product_id: get(this.stepToEdit, "product.id"),
          offer_id: get(this.stepToEdit, "offer.id"),
          plan_id: get(this.stepToEdit, "plan.id")
        }
      )
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("funnel", ["tree"]),
    ...mapState("offer", ["offers"]),
    ...mapState("plan", ["plans"]),
    productList() {
      let treeMap = new Map(this.tree.map(funnel => [funnel.id, funnel]));
      let currentStep =
        this.action == "first-step"
          ? this.tree[0]
          : this.editing
          ? this.stepToEdit
          : this.parent;

      let productsMap = new Map(
        this.products
          .filter(
            p => p.status === "active" && p.type_product !== "onsite_event"
          )
          .map(product => [product.id, product])
      );

      productsMap.delete(this.tree[0].product.id);
      if (!this.editing && this.action == "yes") {
        productsMap.delete(this.parent.product.id);
      }

      while (currentStep.parent) {
        let parent = treeMap.get(currentStep.parent);
        if (parent.action_yes && parent.action_yes.id === currentStep.id) {
          productsMap.delete(parent.product.id);
        }
        currentStep = parent;
      }

      return Array.from(productsMap.values());
    },
    selectedProduct() {
      return this.products.find(p => p.id === this.form.product_id);
    },
    productPlans() {
      return this.plans.filter(
        p => p.status === "active" && (!p.is_stock || p.stock > p.stock_sales)
      );
    },
    productOffers() {
      return this.offers.filter(
        o => o.status === "active" && (!o.is_stock || o.stock > o.stock_sales)
      );
    },
    isSignature() {
      return get(this.selectedProduct, "type_product") === "signature";
    },
    isValid() {
      return (
        (this.tabIndex === 0 &&
          this.form.name &&
          this.form.cta_text &&
          this.form.ctb_text &&
          (this.form.offer_id || this.form.plan_id)) ||
        (this.tabIndex === 1 && this.form.name && this.form.url_cta)
      );
    },
    parent() {
      return this.tree.find(f => f.id === this.form.parent) || {};
    },
    editing() {
      return !this.action;
    }
  },
  methods: {
    submit() {
      this.loading = true;

      if (!this.checkForwards()) {
        this.$message.error(
          "Este produto já está sendo ofertado em seguida como upsell"
        );
        this.loading = false;
        return;
      }

      if (this.tabIndex == 1) {
        this.form = {
          ...this.form,
          is_end: true,
          cta_text: undefined,
          ctb_text: undefined,
          product_id: undefined,
          offer_id: undefined,
          plan_id: undefined
        };
      }

      this.action ? this.postStep() : this.updateFunnel(this.form);
    },
    checkForwards() {
      if (!this.editing) return true;

      let product = this.form.product_id;
      let currentStep = this.stepToEdit;
      let treeMap = new Map(this.tree.map(funnel => [funnel.id, funnel]));

      while (!!currentStep.action_yes) {
        if (currentStep.action_yes.product.id == product) {
          return false;
        }
        currentStep = treeMap.get(currentStep.action_yes.id);
      }

      return true;
    },
    updateFunnel(funnel) {
      ["action_yes", "action_no", "plan", "offer", "product"].forEach(i => {
        delete funnel[i];
      });

      this.$store
        .dispatch("funnel/put", clearObject(funnel))
        .then(({ data }) => {
          if (this.editing) {
            let tree = [...this.tree];
            let index = this.tree.findIndex(f => f.id === data.id);
            tree[index] = data;
            this.$store.commit("funnel/setTree", tree);
          } else this.$emit("addStep");
          this.$emit("close");
        })
        .catch(error => {
          if (error.response?.data?.url_cta) {
            this.$message.error("Insira um URL válido");
          } else this.$message.error("Erro ao salvar funil");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    postStep() {
      let form = clearObject({
        ...this.form,
        position_x:
          this.parent?.position_x !== null
            ? parseInt(this.parent.position_x) + 550
            : 0,
        position_y:
          this.parent?.position_y !== null
            ? parseInt(this.parent.position_y) +
              (this.action === "no" ? 200 : -200)
            : 0,
        scale: 0,
        sort: this.tree.length
      });

      this.$store
        .dispatch("funnel/post", form)
        .then(({ data }) => {
          let tree = [...this.tree];
          let index = this.tree.findIndex(f => f.id === this.parent.id);

          if (this.action !== "first-action") {
            tree[index][`action_${this.action}`] = clearObject({
              id: data.id,
              name: data.name,
              offer: data.offer,
              plan: data.plan,
              product: data.product
            });
          }

          this.$store.commit("funnel/setTree", [...tree, data]);

          if (this.action !== "first-step") {
            let parent = {
              ...this.parent,
              position_x: parseInt(this.parent.position_x),
              position_y: parseInt(this.parent.position_y)
            };
            parent[`action_${this.action}_id`] = data.id;
            delete parent.action_yes;
            delete parent.action_no;
            this.updateFunnel(parent);
          } else {
            this.$emit("addStep");
            this.$emit("close");
          }
        })
        .catch(error => {
          if (error.response?.data?.url_cta) {
            this.$message.error("Insira um URL válido");
          } else this.$message.error("Erro ao criar funil");
          this.loading = false;
        });
      this.loading = false;
    }
  },
  mounted() {
    this.loadingProducts = true;
    this.$store.dispatch("product/get", { limit: 500 }).then(() => {
      this.loadingProducts = false;
    });
  },
  watch: {
    selectedProduct() {
      this.loadingOffersPlans = true;
      this.$store
        .dispatch(this.isSignature ? "plan/get" : "offer/get", {
          product_id: this.form.product_id
        })
        .then(() => {
          this.loadingOffersPlans = false;
        });
    },
    tabIndex() {
      this.form.url_cta = "";
    },
    "form.product_id"() {
      this.form.offer_id = this.form.plan_id = "";
    }
  }
};
</script>
<style lang="scss" scoped>
.funnel-content {
  img {
    height: 52px;
    aspect-ratio: 1;
    border-radius: 4px;
  }
  ::v-deep .tabs {
    &.editing {
      ul {
        display: none;
      }
    }
  }
}
</style>
